import { HttpAxiosRequest } from "../../../../../http/httpAxiosBase";
import {
  FormOperacionCorporateLendingDetalle,
  OperacionCorporateLending,
  OperacionCorporateLendingDetalle, schemaFormOperacionCorporateLending, schemaFormOperacionCorporateLendingDetalle,
  schemaOperacionCorporateLending,
  schemaOperacionCorporateLendingDetalle
} from "../types/types";
import { BaseResponse } from "../../../../../types";
import {
  OperacionCorporateLendingInsertDTO,
  OperacionCorporateLendingViewDTO,
  schemaOperacionCorporateLendingInsert, schemaOperacionCorporateLendingView
} from "../types/dto";
import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";


export const getEndpoint = (url = '') => `operaciones/corporate-lending${url}`;

export const HttpCorporateLending = {
  get: (idOperacion: number): Promise<OperacionCorporateLendingViewDTO> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
      .then(response => {
        const parsed = schemaOperacionCorporateLendingView.safeParse(response);

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues);

          return Promise.reject(new Error('Error de validación.'));
        }

        return parsed.data;
      })
      .catch(error => {
        console.error('Error de red:', error);

        return Promise.reject('Error de red.');
      });
  },

  post: (operacion: OperacionCorporateLendingInsertDTO): Promise<BaseResponse> => {
    const parsed = schemaOperacionCorporateLendingInsert.safeParse(operacion);

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues);

      return Promise.reject(new Error('Error de validación.'));
    }

    return HttpAxiosRequest.post(getEndpoint(), parsed.data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        console.error('Error de red:', error);

        return Promise.reject('Error de red.');
      });
  },
  getDetalle: (idOperacion: number): Promise<OperacionCorporateLendingDetalle> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}/detalles`))
      .then(response => {
        const parsed = schemaOperacionCorporateLendingDetalle.safeParse(response);

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues);

          return Promise.reject(new Error('Error de validación.'));
        }

        return parsed.data;
      })
      .catch(error => {
        console.error('Error de red:', error);

        return Promise.reject('Error de red.');
      });
  },
  putDetalle: (idOperacion: number, idOperacionDetalle: number, detalle: FormOperacionCorporateLendingDetalle): Promise<BaseResponse> => {
    const parsed = schemaFormOperacionCorporateLendingDetalle.safeParse(detalle);

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues);

      return Promise.reject(new Error('Error de validación.'));
    }

    return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}/detalles/${idOperacionDetalle}`), parsed.data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        console.error('Error de red:', error);

        return Promise.reject('Error de red.');
      });
  },
  descargarInforme: (idOperacion: number): Promise<any> =>
      HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.CorporateLending),
};